/* eslint-disable @typescript-eslint/no-empty-interface */
import { ISchema, IGetObjectsData } from '../types'
import { IObjectBoardConfig } from 'src/helpers/storageObjects'
import { IUser } from 'src/hooks/useUsers'
import { IStorageFilterRule } from 'src/modals/storageFilters/components/FilterField'
import { IGroup } from 'src/services/auth/groups'

export interface IPostSmartListDataScheme {
  id: number
  identifier: string
  title: string
  children: number
  primaryFieldSchemeId: number
  secondaryFieldSchemeId: number
  iconFieldSchemeId: number
}
export interface ISmartListUserOptions {
  columns?: {
    identifier: string
    enable: boolean
    width?: number
    index: number
  }[]
  board?: IObjectBoardConfig
}

enum ESmartListUserAbilities {
  show = 'show',
  update = 'update',
  destroy = 'destroy',
}

export interface ISmartList {
  id: number
  title: string
  type: string //  example: smart
  objectSchemeId: number
  filter: IStorageFilterRule
  createdBy: number
  createdAt: string
  updatedAt: string
  deletedAt: string
  scheme: ISchema
  objects: IGetObjectsData[]
  allowedUsers: { id: number; info: {} }[]
  allowedGroups: { id: number }[]
  userOptions?: ISmartListUserOptions
  userAbilities: `${ESmartListUserAbilities}`
}

export interface IGetSmartListParams {
  schemeName: string
  cursor?: string
  perPage?: number
}

export type IGetSmartListData = ISmartList[]

export interface IPutSmartListParams {
  schemeName: string
  uniqId: number
  data: {
    type: string
    title: string
    filter?: IStorageFilterRule
    objectIds?: string[]
    userOptions?: ISmartListUserOptions
  }
}

export interface IPutSmartListDefaultParams {
  schemeName: string
  data: {
    userOptions?: ISmartListUserOptions
  }
}

export interface IPostManualListObjectsAssignParams {
  schemeName: string
  uniqId: number
  objectsUniqIds: string[]
}
export type IPostManualListObjectsAssignData = ISmartList

export interface IPostManualListObjectsRemoveParams {
  schemeName: string
  uniqId: number
  objectsUniqIds: string[]
}
export type IPostManualListObjectsRemoveData = ISmartList

export interface IGetSmartListItemDefaultParams {
  schemeName: string
}
export interface IGetSmartListItemParams {
  schemeName: string
  uniqId: number
}
export interface IGetSmartListItemData extends ISmartList {}

export interface IPutSmartListData extends ISmartList {}

export interface IPostSmartListParams {
  schemeName: string
  data: {
    type: string
    title: string
    filter?: IStorageFilterRule
    objectIds?: string[]
    userOptions?: ISmartListUserOptions
  }
}

export interface IPostSmartListData extends ISmartList {}

export interface IDeleteSmartListParams {
  schemeName: string
  uniqId: number
}

export interface IDeleteSmartListData {}

export interface IAddSmartListUsersParams {
  schemeName: string
  uniqId: number
  usersIds: number[]
}
export interface IRemoveSmartListUsersParams {
  schemeName: string
  uniqId: number
  usersIds: number[]
}
export interface IAddSmartListGroupsParams {
  schemeName: string
  uniqId: number
  groupsIds: number[]
}
export interface IRemoveSmartListGroupsParams {
  schemeName: string
  uniqId: number
  groupsIds: number[]
}

export interface IGetSmartListPermissionsParams {
  schemeName: string
  uniqId: number
}

export interface IGetSmartListPermissionsDataUserItem {
  userId: number
  userData: IUser
  permissionsSlug: `${ESmartListPermissions}`[]
}
export interface IGetSmartListPermissionsDataGroupItem {
  groupSlug: string
  groupData: IGroup
  permissionsSlug: `${ESmartListPermissions}`[]
}
export interface IGetSmartListPermissionsData {
  usersPermissions: IGetSmartListPermissionsDataUserItem[]
  groupsPermissions: IGetSmartListPermissionsDataGroupItem[]
}
export interface IPostSmartListPermissionsParams {
  schemeName: string
  uniqId: number
  usersPermissions: IPostSmartListPermissionsDataUserItem[]
  groupsPermissions: IPostSmartListPermissionsDataGroupItem[]
}

export interface IPostSmartListPermissionsDataUserItem {
  userId: number
  permissionsSlug: `${ESmartListPermissions}`[]
}
export interface IPostSmartListPermissionsDataGroupItem {
  groupSlug: string
  permissionsSlug: `${ESmartListPermissions}`[]
}
export interface IPostSmartListPermissionsData {
  usersPermissions: IPostSmartListPermissionsDataUserItem[]
  groupsPermissions: IPostSmartListPermissionsDataGroupItem[]
}

export enum ESmartListPermissions {
  itemUpdate = 'storage.smart-lists.item.update',
  objectsView = 'storage.smart-lists.item.objects.view',
  objectsEdit = 'storage.smart-lists.item.objects.edit',
}
export interface IPostSmartListPermissionsUsersAddParams {
  schemeName: string
  uniqId: number
  usersIds: number[]
  permissions: string[]
}
export interface IPostSmartListPermissionsUsersRemoveParams {
  schemeName: string
  uniqId: number
  usersIds: number[]
  permissions: string[]
}

export interface IPostSmartListPermissionsGroupsAddParams {
  schemeName: string
  uniqId: number
  groupsSlug: string[]
  permissions: string[]
}
export interface IPostSmartListPermissionsGroupsRemoveParams {
  schemeName: string
  uniqId: number
  groupsSlug: string[]
  permissions: string[]
}

export interface IGetSmartListUserOptionsParams {
  schemeName: string
  uniqId: number
}

export interface IGetSmartListUserOptionsData extends ISmartListUserOptions {}

export interface IPatchSmartListUserOptionsParams {
  schemeName: string
  uniqId: number
  userOptions: ISmartListUserOptions
}

export interface IPatchSmartListUserOptionsData extends ISmartListUserOptions {}

export interface IGetSmartListDefaultUserOptionsParams {
  schemeName: string
}

export interface IGetSmartListDefaultUserOptionsData
  extends ISmartListUserOptions {}

export interface IPatchSmartListDefaultUserOptionsParams {
  schemeName: string
  userOptions: ISmartListUserOptions
}

export interface IPatchSmartListDefaultUserOptionsData
  extends ISmartListUserOptions {}
